exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".in-cart{border-left:4px solid #01ad83!important}", ""]);

// exports
